/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedulworkshopstress4Inputs */

const de__field_participatedulworkshopstress4 = /** @type {(inputs: _Field_Participatedulworkshopstress4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an ÜL-Workshop Stress`)
};

/**

* @param {_Field_Participatedulworkshopstress4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedulworkshopstress4 = /** @type {((inputs?: _Field_Participatedulworkshopstress4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedulworkshopstress4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedulworkshopstress4(inputs)
});
export { _field_participatedulworkshopstress4 as "_field_participatedULWorkshopStress" }